import { Tab, Tabs } from '@components/tabs';
import { Organization } from '@generated/graphql';
import { Box, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { OrganizationAnnotationMaps } from './annotationMaps';
import { OrganizationChannels } from './channels';
import { OrganizationGanModels } from './ganModels';
import { OrganizationVolumes } from './volumes';
import { OrganizationWorkspaces } from './workspaces';

export const LandingPageOrganizationContent = ({
  organization,
}: {
  organization: Organization;
}) => {
  const [tab, setTab] = useState<string>(
    new URLSearchParams(window.location.search).get('tab') || '',
  );

  useEffect(() => {
    setTab(new URLSearchParams(window.location.search).get('tab') || '');
  }, [organization]);

  const handleChange = (_, newTabValue: string) => {
    setTab(newTabValue);
    const url = new URL(window.location.href);
    if (newTabValue) {
      url.searchParams.set('tab', newTabValue);
    } else {
      url.searchParams.delete('tab');
    }
    window.history.pushState({}, '', url.toString());
  };

  return (
    <Stack sx={{ flex: 1, height: '100%', overflow: 'hidden', mt: 5 }}>
      <Tabs
        value={tab}
        onChange={handleChange}
        sx={{ '& .MuiTab-root': { minWidth: 0, paddingX: '12px !important' } }}
      >
        <Tab value="" label="Workspaces" />
        <Tab value="channels" label="Channels" />
        <Tab value="volumes" label="Volumes" />
        <Tab value="gan-models" label="GAN Models" />
        <Tab value="annotation-maps" label="Annotation Maps" />
      </Tabs>
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {tab === '' && <OrganizationWorkspaces organization={organization} />}
        {tab === 'channels' && (
          <OrganizationChannels organizationId={organization.organizationId} />
        )}
        {tab === 'volumes' && <OrganizationVolumes organizationId={organization.organizationId} />}
        {tab === 'gan-models' && (
          <OrganizationGanModels organizationId={organization.organizationId} />
        )}
        {tab === 'annotation-maps' && (
          <OrganizationAnnotationMaps organizationId={organization.organizationId} />
        )}
      </Box>
    </Stack>
  );
};
